(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initCartForms();
    initGallery();
    initGridToggle();
    loadCartCount();
    initFilterClose();
    handleHash();
  }

  // === CARRINHO ===
  function initCartForms() {
    document.querySelectorAll('.luxury-cart-form').forEach(function(form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        e.stopPropagation();

        var button = this.querySelector('.luxury-cart-btn');
        button.disabled = true;
        button.classList.add('is-loading');

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(this)
          });

          var cartData = await (await fetch('/cart.js')).json();
          updateCartCount(cartData.item_count);
          openCartDrawer();

          button.classList.add('is-success');
          setTimeout(function() { button.classList.remove('is-success'); }, 400);

        } catch (error) {
          button.classList.add('is-error');
          setTimeout(function() { button.classList.remove('is-error'); }, 1500);
        } finally {
          setTimeout(function() {
            button.disabled = false;
            button.classList.remove('is-loading', 'is-success', 'is-error');
          }, 300);
        }
      });
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function(counter) {
      counter.textContent = count;
    });
    var mobileCount = document.getElementById('mobileCartCount');
    if (mobileCount) {
      mobileCount.textContent = count;
      mobileCount.style.display = count > 0 ? 'flex' : 'none';
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count } }));
  }

  function openCartDrawer() {
    /* FIX v5.1: tenta primeiro o drawer customizado do header Sanctuary,
       que é o único garantido de estar na página */
    if (typeof window.openCartSanctuary === 'function') return window.openCartSanctuary();
    if (typeof window.openCart === 'function') return window.openCart();
    if (typeof window.openCartDrawer === 'function') return window.openCartDrawer();

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.open === 'function') return cartDrawer.open();
      return cartDrawer.classList.add('active', 'animate', 'open');
    }

    var drawer = document.querySelector('[data-cart-drawer], .cart-drawer');
    if (drawer) return drawer.classList.add('active', 'open', 'animate');

    var cartBtn = document.querySelector('[data-cart-drawer-trigger], .header__icon--cart, #cart-icon-bubble');
    if (cartBtn) cartBtn.click();
  }

  // === GALERIA ===
  function initGallery() {
    document.querySelectorAll('.luxury-product-card').forEach(function(card) {
      var gallery = card.querySelector('.luxury-image-gallery');
      if (!gallery) return;

      var mediaItems = gallery.querySelectorAll('.luxury-card__media');
      var dots       = gallery.querySelectorAll('.luxury-dot');
      var arrowLeft  = gallery.querySelector('.luxury-arrow-left');
      var arrowRight = gallery.querySelector('.luxury-arrow-right');

      if (mediaItems.length <= 1) return;

      var currentIndex = 0;
      var hasMouseEntered = false;

      mediaItems.forEach(function(media, index) {
        var video = media.querySelector('video');
        if (video && index <= 1) {
          video.load();
          video.addEventListener('loadeddata', function() {
            media.classList.add('is-loaded');
          }, { once: true });
        }
      });

      function showMedia(index) {
        mediaItems.forEach(function(media, i) {
          var video = media.querySelector('video');
          if (i === index) {
            media.classList.add('is-active');
            if (video) {
              if (!media.classList.contains('is-loaded')) video.load();
              video.currentTime = 0;
              video.play().catch(function() {});
            }
          } else {
            media.classList.remove('is-active');
            if (video) { video.pause(); video.currentTime = 0; }
          }
        });
        dots.forEach(function(dot, i) { dot.classList.toggle('is-active', i === index); });
        currentIndex = index;
      }

      function goToNext() {
        var nextIndex = (currentIndex + 1) % mediaItems.length;
        var nextMedia = mediaItems[nextIndex];
        var nextVideo = nextMedia.querySelector('video');
        if (nextVideo && !nextMedia.classList.contains('is-loaded')) nextVideo.load();
        showMedia(nextIndex);
      }
      function goToPrev() {
        showMedia((currentIndex - 1 + mediaItems.length) % mediaItems.length);
      }

      if (window.innerWidth >= 750) {
        card.addEventListener('mouseenter', function() {
          if (!hasMouseEntered && mediaItems.length > 1) {
            hasMouseEntered = true;
            showMedia(1);
          }
        });
        card.addEventListener('mouseleave', function() {
          hasMouseEntered = false;
          showMedia(0);
        });
      }

      if (arrowLeft) {
        arrowLeft.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goToPrev(); });
      }
      if (arrowRight) {
        arrowRight.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goToNext(); });
      }

      var touchStartX = 0;
      gallery.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      gallery.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) { diff > 0 ? goToNext() : goToPrev(); }
      }, { passive: true });

      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showMedia(index); });
      });

      showMedia(0);
    });
  }

  // === GRID TOGGLE — FIX v5.1: guard no productsGrid ===
  function initGridToggle() {
    var gridIcons    = document.querySelectorAll('.luxury-grid-icon');
    var productsGrid = document.querySelector('.luxury-products-grid');

    // Guard: se não existe grid na página, não tenta manipulá-lo
    if (!productsGrid) return;

    productsGrid.classList.add('is-grid-view');

    gridIcons.forEach(function(icon) {
      icon.addEventListener('click', function() {
        gridIcons.forEach(function(i) { i.classList.remove('active'); });
        this.classList.add('active');
        if (this.getAttribute('data-grid') === '1') {
          productsGrid.classList.add('is-list-view');
          productsGrid.classList.remove('is-grid-view');
        } else {
          productsGrid.classList.remove('is-list-view');
          productsGrid.classList.add('is-grid-view');
        }
      });
    });
  }

  // === CARREGAR CONTADOR ===
  function loadCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var counter = document.getElementById('mobileCartCount');
        if (counter && data.item_count > 0) {
          counter.textContent = data.item_count;
          counter.style.display = 'flex';
        }
      })
      .catch(function() {});
  }

  // === FECHAR FILTROS ===
  function initFilterClose() {
    document.addEventListener('click', function(e) {
      document.querySelectorAll('.luxury-filter-group[open]').forEach(function(filter) {
        if (!filter.contains(e.target)) filter.removeAttribute('open');
      });
    });
  }

  // === HASH URL — FIX v5.1: não aninha DOMContentLoaded dentro de DOMContentLoaded ===
  function handleHash() {
    var hash = window.location.hash;
    if (!hash) return;
    // O init() já roda após DOMContentLoaded, então o DOM está pronto
    var element = document.getElementById(hash.slice(1));
    if (element) element.scrollIntoView({ behavior: 'instant' });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
